import { render, staticRenderFns } from "./self-button.vue?vue&type=template&id=940c63ac&scoped=true&"
import script from "./self-button.vue?vue&type=script&lang=js&"
export * from "./self-button.vue?vue&type=script&lang=js&"
import style0 from "./self-button.vue?vue&type=style&index=0&id=940c63ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940c63ac",
  null
  
)

export default component.exports